module.exports = __webpack_public_path__ + "static/surepulse-9b9766445163551803ae87778a78f94a.png";